import { useFirestoreGeneral } from "../../firebase/useFirestore";

const SubTargetgroupMeta = ({targetgroupID}) => {

    const targetgroup = useFirestoreGeneral('SubTargetgroups', 'ID', targetgroupID || '')

  return (
    <p>{targetgroup[0]?.Title}</p>
  )
}

export default SubTargetgroupMeta